module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home d-flex flex-column justify-content-start"
  }, [_c('div', {
    staticClass: "row h-100"
  }, [_c('div', {
    staticClass: "col-md-9 h-100 overflow-auto"
  }, [_c('dashboard-feed-top', {
    attrs: {
      "filterButtons": _vm.buttons,
      "feedFilter": _vm.feedFilter,
      "locked": _vm.showFirstTasks
    },
    on: {
      "filterChanged": function($event) {
        _vm.feedFilter = $event
      }
    }
  }), _vm._v(" "), (_vm.showFirstTasks) ? _c('dashboard-starting-tasks', {
    on: {
      "forceSkipTasks": _vm.forceSkipTasks,
      "skipTasksForNow": _vm.skipTasksForNow
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFeed) ? _c('dashboard-feed', {
    attrs: {
      "cards": _vm.feedCards,
      "filter": _vm.feedFilter
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dashboard-side-panel')], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-5927c089", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5927c089"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/Home.vue
// module id = 2464
// module chunks = 0